import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BrandLogo } from "@/components/Logo";

function LegalShell({ title, children }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2"><BrandLogo /></Link>
          <Link to="/" className="text-sm text-slate-500 flex items-center gap-1 hover:text-primary" data-testid="legal-home-link"><ArrowLeft className="w-4 h-4" /> Home</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <h1 className="text-3xl font-bold text-slate-900">{title}</h1>
        <div className="mt-6 space-y-4 text-slate-600 leading-relaxed text-sm">{children}</div>
      </main>
    </div>
  );
}

export default function Privacy() {
  return (
    <LegalShell title="Privacy Policy">
      <p>This Privacy Policy explains how Pack Mate collects, uses, and protects your information when you use our platform to connect senders and travellers.</p>
      <h3 className="font-semibold text-slate-800 text-base">Information we collect</h3>
      <p>We collect your name, email, phone number, and the trip and delivery details you provide. Passwords are stored only as secure hashes and are never visible to us or anyone else.</p>
      <h3 className="font-semibold text-slate-800 text-base">How we use your information</h3>
      <p>Your information is used to operate the marketplace: matching senders with travellers, enabling messaging after a connection, and sending relevant notifications. We do not sell your personal data.</p>
      <h3 className="font-semibold text-slate-800 text-base">Verification documents</h3>
      <p>Any government ID submitted for verification is never displayed publicly or shared with other users. Only a verification status badge is shown.</p>
      <h3 className="font-semibold text-slate-800 text-base">Account deletion</h3>
      <p>You may delete your account at any time from Settings, or via our <a href="https://sites.google.com/view/pack-mate/delete-account" target="_blank" rel="noreferrer" className="text-primary underline">account deletion page</a>. Some information may be retained where required or permitted by law.</p>
    </LegalShell>
  );
}
